import { FaIcon } from "@components/FaIcon";
import { useToggle } from "@hooks/useToggle";
import { Collapse, Divider, List, ListItem, ListItemIcon, ListItemText, makeStyles } from "@material-ui/core";
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import DescriptionIcon from '@material-ui/icons/Description';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import HomeIcon from '@material-ui/icons/Home';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import MemoryIcon from '@material-ui/icons/Memory';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import PersonIcon from '@material-ui/icons/Person';
import React, { MouseEventHandler } from "react";
import { NavLink } from "react-router-dom";
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import PermScanWifiIcon from '@material-ui/icons/PermScanWifi';
import { useAuth } from "@components/AuthProvider";
import { Permission } from "./Permission";
import PhoneIcon from '@material-ui/icons/Phone';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';

const useStyles = makeStyles(theme => ({
    menuLevel1: {
        paddingLeft: theme.spacing(4),
    }
}));

export type AppMenuProps = {
    onDrawerItemClick?: MouseEventHandler<HTMLAnchorElement>
}

export default function AppMenu({ onDrawerItemClick }: AppMenuProps) {
    const classes = useStyles();

    const arquivoToggle = useToggle();
    const relatorioToggle = useToggle();
    const caixaToggle = useToggle();
    const auth = useAuth();

    return (
        <List>
            <ListItem button component={NavLink} to={"/"} onClick={onDrawerItemClick}>
                <ListItemIcon>
                    <HomeIcon />
                </ListItemIcon>
                <ListItemText primary="Início" />
            </ListItem>

            <Divider />

            <ListItem button component={NavLink} to="/cliente" onClick={onDrawerItemClick}>
                <ListItemIcon>
                    <PersonIcon />
                </ListItemIcon>
                <ListItemText primary="Clientes" />
            </ListItem>

            <ListItem button component={NavLink} to="/contrato" onClick={onDrawerItemClick}>
                <ListItemIcon>
                    <LibraryBooksIcon />
                </ListItemIcon>
                <ListItemText primary="Contratos" />
            </ListItem>

            <ListItem button onClick={caixaToggle.handleTick}>
                <ListItemIcon>
                    <MonetizationOnIcon />
                </ListItemIcon>
                <ListItemText primary="Caixas" />
                {caixaToggle.value ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={caixaToggle.value} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItem button component={NavLink} to="/caixa" onClick={onDrawerItemClick} className={classes.menuLevel1}>
                        <ListItemText primary="Por Proprietário" />
                    </ListItem>

                    <ListItem button component={NavLink} to="/caixa-pesquisa" onClick={onDrawerItemClick} className={classes.menuLevel1}>
                        <ListItemText primary="Pesquisar Descrição" />
                    </ListItem>
                </List>
            </Collapse>

            <ListItem button component={NavLink} to="/conta" onClick={onDrawerItemClick}>
                <ListItemIcon>
                    <FaIcon icon="fa-solid fa-file-invoice" />
                </ListItemIcon>
                <ListItemText primary="Contas" />
            </ListItem>

            <ListItem button component={NavLink} to="/excedente" onClick={onDrawerItemClick}>
                <ListItemIcon>
                    <FaIcon icon="fas fa-search-plus" />
                </ListItemIcon>
                <ListItemText primary="Excedentes" />
            </ListItem>

            {
                /*
            <ListItem button component={NavLink} to={AppAddress.LINHA} onClick={onDrawerItemClick}>
                <ListItemIcon>
                    <PhoneIcon />
                </ListItemIcon>
                <ListItemText primary="Linhas"/>
            </ListItem>

            <ListItem button component={NavLink} to={AppAddress.DESPESA} onClick={onDrawerItemClick}>
                <ListItemIcon>
                    <RemoveCircleIcon />
                </ListItemIcon>
                <ListItemText primary="Despesas"/>
            </ListItem>
                */
            }

            <ListItem button component={NavLink} to="/fatura" onClick={onDrawerItemClick}>
                <ListItemIcon>
                    <FaIcon icon="fa-solid fa-file-invoice-dollar" />
                </ListItemIcon>
                <ListItemText primary="Faturas" />
            </ListItem>

            <ListItem button component={NavLink} to="/linha" onClick={onDrawerItemClick}>
                <ListItemIcon>
                    <PhoneIcon />
                </ListItemIcon>
                <ListItemText primary="Linhas" />
            </ListItem>

            <ListItem button component={NavLink} to="/vendedor" onClick={onDrawerItemClick}>
                <ListItemIcon>
                    <ShoppingCartIcon />
                </ListItemIcon>
                <ListItemText primary="Vendedores" />
            </ListItem>

            <ListItem button onClick={arquivoToggle.handleTick}>
                <ListItemIcon>
                    <FaIcon icon="fa-solid fa-exchange-alt" />
                </ListItemIcon>
                <ListItemText primary="Arquivos" />
                {arquivoToggle.value ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={arquivoToggle.value} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItem button component={NavLink} to="/remessa" onClick={onDrawerItemClick} className={classes.menuLevel1}>
                        <ListItemIcon>
                            <ArrowUpwardIcon />
                        </ListItemIcon>
                        <ListItemText primary="Remessa" />
                    </ListItem>

                    <ListItem button component={NavLink} to="/retorno" onClick={onDrawerItemClick} className={classes.menuLevel1}>
                        <ListItemIcon>
                            <ArrowDownwardIcon />
                        </ListItemIcon>
                        <ListItemText primary="Retorno" />
                    </ListItem>
                </List>
            </Collapse>

            <ListItem button onClick={relatorioToggle.handleTick}>
                <ListItemIcon>
                    <DescriptionIcon />
                </ListItemIcon>
                <ListItemText primary="Relatórios" />
                {relatorioToggle.value ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={relatorioToggle.value} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <ListItem button component={NavLink} to="/relatorio-status-linha" onClick={onDrawerItemClick} className={classes.menuLevel1}>
                        <ListItemIcon>
                            <MemoryIcon />
                        </ListItemIcon>
                        <ListItemText primary="Status das Linhas" />
                    </ListItem>

                    <ListItem button component={NavLink} to="/relatorio-faturas" onClick={onDrawerItemClick} className={classes.menuLevel1}>
                        <ListItemIcon>
                            <FaIcon icon="fa-solid fa-file-invoice-dollar" />
                        </ListItemIcon>
                        <ListItemText primary="Faturas" />
                    </ListItem>

                    <ListItem button component={NavLink} to="/relatorio-inadimplencia-fatura" onClick={onDrawerItemClick} className={classes.menuLevel1}>
                        <ListItemIcon>
                            <ReportProblemIcon />
                        </ListItemIcon>
                        <ListItemText primary="Inadimplência" secondary="Por Fatura" />
                    </ListItem>

                    <ListItem button component={NavLink} to="/relatorio-novos-inadimplentes" onClick={onDrawerItemClick} className={classes.menuLevel1}>
                        <ListItemIcon>
                            <FaIcon icon="fa-solid fa-comment-dollar" />
                        </ListItemIcon>
                        <ListItemText primary="Novos Inadimplentes" />
                    </ListItem>

                    <ListItem button component={NavLink} to="/relatorio-pagamento" onClick={onDrawerItemClick} className={classes.menuLevel1}>
                        <ListItemIcon>
                            <AccountBalanceIcon />
                        </ListItemIcon>
                        <ListItemText primary="Pagamentos" />
                    </ListItem>

                    <ListItem button component={NavLink} to="/relatorio-consumo-internet" onClick={onDrawerItemClick} className={classes.menuLevel1}>
                        <ListItemIcon>
                            <PermScanWifiIcon />
                        </ListItemIcon>
                        <ListItemText primary="Consumo Internet" />
                    </ListItem>

                    <ListItem button component={NavLink} to="/relatorio-cancelamento" onClick={onDrawerItemClick} className={classes.menuLevel1}>
                        <ListItemIcon>
                            <FaIcon icon="fa-solid fa-times" />
                        </ListItemIcon>
                        <ListItemText primary="Cancelamento" />
                    </ListItem>

                    <ListItem button component={NavLink} to="/relatorio-valores-emitidos" onClick={onDrawerItemClick} className={classes.menuLevel1}>
                        <ListItemIcon>
                            <FaIcon icon="fa-solid fa-coins" />
                        </ListItemIcon>
                        <ListItemText primary="Valores Emitidos" />
                    </ListItem>

                    <ListItem button component={NavLink} to="/relatorio-valor-franquia-planos" onClick={onDrawerItemClick} className={classes.menuLevel1}>
                        <ListItemIcon>
                            <FaIcon icon="fa-solid fa-hand-holding-usd" />
                        </ListItemIcon>
                        <ListItemText primary="Valores de Planos" />
                    </ListItem>
                </List>
            </Collapse>

            {
                auth.hasPermission(Permission.Despesa) && (
                    <React.Fragment>
                        <ListItem button component={NavLink} to="/despesa" onClick={onDrawerItemClick}>
                            <ListItemIcon>
                                <FaIcon icon="fa-solid fa-minus-circle" />
                            </ListItemIcon>
                            <ListItemText primary="Despesas" />
                        </ListItem>
                    </React.Fragment>
                )
            }

            {
                auth.hasPermission(Permission.Usuario) && (
                    <React.Fragment>
                        <ListItem button component={NavLink} to="/usuario" onClick={onDrawerItemClick}>
                            <ListItemIcon>
                                <FaIcon icon="fa-solid fa-file-invoice-dollar" />
                            </ListItemIcon>
                            <ListItemText primary="Usuários" />
                        </ListItem>
                    </React.Fragment>
                )
            }
        </List>
    )
}